// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "BulkUserInviteRowResultDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { BulkInviteStatus } from "./bulk-invite-status.enum.gen";

export const BulkUserInviteRowResultDtoGenShape = z.strictObject({
  email: z.string(),
  status: z.enum(BulkInviteStatus),
  error: z.string().optional(),
});
